import { isNullOrUndefined } from '../helpers/helpers';

export const rowHasMappedKey = (row, key) => Object.hasOwn(row, key);

export const trimUpdateValue = (value) => (
  isNullOrUndefined(value) ? '' : String(value).trim()
);

export const parseCurrency = (value) => {
  const normalized = trimUpdateValue(value).replace(/[$,\s]/g, '');
  if (normalized === '') return undefined;
  const result = Number.parseFloat(normalized);
  if (Number.isNaN(result)) return undefined;
  return result;
};

export const parsePercent = (value) => {
  const normalized = trimUpdateValue(value).replace('%', '');
  if (normalized === '') return undefined;
  const result = Number.parseFloat(normalized);
  if (Number.isNaN(result)) return undefined;
  return result;
};

export const checkDuplicateKeyInBulkUpdate = ({
  key,
  label,
  seen,
}) => {
  if (seen.has(key)) {
    throw new Error(`${label} "${key}" already exists in the import file; update skipped`);
  }

  seen.add(key);
};

export const getIdByExactName = ({
  name,
  map,
  errorMessage = 'Item not found',
}) => {
  const item = map?.[name];
  if (!item) {
    throw new Error(errorMessage);
  }

  return item.id;
};